module.exports = __webpack_public_path__ + "assets/fonts/fb437504-dd61-4878-b950-0d7c7d7b4298.9d30bb5e.woff";